import React, {createContext, ReactElement} from "react";
import {useQuery} from "@apollo/client";

import {LoadingPage} from "components/loading-page";
import {GET_USER} from "graphql/queries/queries";
import {User} from "models/user";
import LogRocket from "logrocket";

type UserContextProps = {
	user: User
};

const UserContext = createContext<UserContextProps>({
	user: {
		id: "fake",
		email: "fake@email.com",
		firstName: "",
		lastName: "",
		isPublic: false,
		creatorTag: "",
	},
});

const UserContextProvider = (props: {children: ReactElement}): ReactElement => {
	const {data, loading, error} = useQuery(GET_USER);

	if (error) throw new Error(error.message);

	if (loading) return <LoadingPage />;

	if (data?.me) {
		const userIdentity = {
			userId: data.me.id,
			name: data.me.name,
			email: data.me.email,
		};
		LogRocket.identify(userIdentity.userId, userIdentity);
	}

	return (
		<UserContext.Provider value={{user: data?.me}}>
			{props.children}
		</UserContext.Provider>
	);
};

export {UserContext, UserContextProvider};
